module.exports = __webpack_public_path__ + "img/cracker-banana-speciaux.30f894e6.jpg";